import http from '../utils/http'

export const getUploadConfig = (configId) => {
    return http.get(`/api/upload-config/${configId}`)
}

export const getImgUploadConfig = (configId) => {
    return http.get(`/api/image-upload-config/${configId}`)
}
